require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j.json") })
        }
      }, "path---kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j!./.cache/json/kriterien-tagesoeffnungszeiten-oeff-tag-0-3-j.json
// module id = 1105
// module chunks = 231608221292675